export const FomularsätzeAccordionTabs = [
  {
    title: "Von integrierten Formularsätzen profitieren",
    content:
      'VHB Bund (Vergabehandbuch Bund): Hochbau-Bauleistungen nach VOB, Liefer-/Dienstleistungen nach UVgO/VgV (VOL), HVA (B) StB, Landesspezifische Formblätter für Berlin (Bauleistungen Hochbau VOB, Liefer-/Dienstleistungen UVgO/VgV) und Bayern (Bauleistungen Hochbau VOB). <br /> <a href="mailto: vergabe@bi-medien.de">Weitere Formularsätze rüsten wir auf Anfrage gerne nach.</a>',
  },
  {
    title: "Standardschreiben und Formblätter erstellen",
    content:
      "Mit den in B_I eVergabe integrierten Formularsätzen können Sie Standardschreiben und Formblätter wie Bekanntmachung, Eignungsnachweise und Vergabeunterlagen sehr einfach erstellen. Bei der Generierung der Dokumente wird automatisch auf Plausibilität und Vollständigkeit geprüft.",
  },
  {
    title: "Angaben automatisch wiederverwenden",
    content:
      'Angaben die in mehreren Formularen vorkommen, werden automatisch übernommen, sodass Sie die Informationen – zum Beispiel gewählte <a href="/vergabe-wissen/lexikon/fristenuebersicht">Termine und Fristen</a> – nur ein einziges Mal ausfüllen müssen. Sind alle Schreiben erstellt und ist die Vergabe freigegeben, können Bieter die Formulare direkt im Browser ausfüllen – ein Medienbruch bleibt Ihnen und Ihren Bietern erspart.',
  },
]
